/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'group': {
    width: 18,
    height: 14,
    viewBox: '0 0 18 14',
    data: '<path pid="0" _fill="#377CCE" d="M16.2 1.75H9.6V.583A.592.592 0 009 0H3c-.331 0-.6.261-.6.583V1.75h-.6C.806 1.75 0 2.534 0 3.5v8.75C0 13.216.806 14 1.8 14h14.4c.994 0 1.8-.784 1.8-1.75V3.5c0-.966-.806-1.75-1.8-1.75zm.6 10.5a.592.592 0 01-.6.583H1.8a.592.592 0 01-.6-.583v-7h15.6v7zm0-8.167H1.2V3.5c0-.322.269-.583.6-.583H3c.331 0 .6-.262.6-.584V1.167h4.8v1.166c0 .322.269.584.6.584h7.2c.331 0 .6.26.6.583v.583z"/>'
  }
})
